/**
 * Globals injected into every script bundle by the Gulp build (see gulpfile.js),
 * mirroring webpack's ProvidePlugin config in webpack.config.js.
 *
 * `jquery` resolves to WordPress's global jQuery, so `$` works inside
 * modules even though WordPress loads jQuery in noConflict mode.
 */
import jQuery from 'jquery';
import Popper from 'popper.js/dist/umd/popper.js';

export { jQuery, jQuery as $, Popper };
